import { useEffect, useState } from 'react';
import { isAdsEnabled } from '@/lib/ads';
// Módulo-folha (não o barril): o consentimento também monta no bundle do blog.
import { useAuth } from '@/lib/auth/context';
import { COOKIE_NOTICE_KEY, COOKIE_SETTINGS_EVENT, useConsent } from '@/lib/consent';
import { CookieBanner } from './CookieBanner';
import { CookieNotice } from './CookieNotice';
import { CookieSettingsDialog } from './CookieSettingsDialog';
import './CookieConsent.css';

function readNoticeDismissed(): boolean {
  try {
    return localStorage.getItem(COOKIE_NOTICE_KEY) === 'dismissed';
  } catch {
    return false;
  }
}

function persistNoticeDismissed(): void {
  try {
    localStorage.setItem(COOKIE_NOTICE_KEY, 'dismissed');
  } catch {
    // Sem armazenamento (modo privado restrito) o aviso só volta na próxima visita.
  }
}

/**
 * O ponto único da conversa sobre cookies, montado na raiz para valer em todas
 * as rotas. Decide entre a PERGUNTA (há categoria opcional em uso — anúncios para
 * o visitante anônimo — e nenhuma escolha válida) e o AVISO informativo (só
 * necessários), e é dono do painel de preferências, que qualquer ponto da
 * interface reabre por `openCookieSettings()`.
 */
export function CookieConsent(): JSX.Element | null {
  const { status } = useAuth();
  const consent = useConsent();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [noticeDismissed, setNoticeDismissed] = useState(readNoticeDismissed);

  useEffect(() => {
    const open = (): void => setSettingsOpen(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, open);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, open);
  }, []);

  const dismissNotice = (): void => {
    persistNoticeDismissed();
    setNoticeDismissed(true);
  };

  // Enquanto a sessão resolve não se sabe se há anúncio em jogo: nada a dizer ainda.
  const resolved = status !== 'loading';
  const optionalInUse = isAdsEnabled() && status === 'unauthenticated';
  const showBanner = resolved && optionalInUse && !consent.decided;
  const showNotice = resolved && !optionalInUse && !consent.decided && !noticeDismissed;

  return (
    <>
      {showBanner && <CookieBanner gpc={consent.gpc} onCustomize={() => setSettingsOpen(true)} />}
      {showNotice && <CookieNotice onDismiss={dismissNotice} />}
      <CookieSettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
}
